import { AfterViewInit, Component, Input } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
declare const CanvasJS: any;

@Component({
	selector: 'pk-web-cost-estimator-chart',
	templateUrl: './cost-estimator-chart.component.html',
	styleUrl: './cost-estimator-chart.component.scss'
})
export class CostEstimatorChartComponent implements AfterViewInit {
	@Input() saveUpToPercent: number;

	ngAfterViewInit(): void {
		const chart = new CanvasJS.Chart('chartContainer', {
			animationEnabled: true,
			aspectRatio: 1,
			width: 250,
			height: 250,
			backgroundColor: '#214A86',
			interactivityEnabled: false,
			toolTip: {
				enabled: false,
			},
			data: [{
				type: 'doughnut',
				radius: '100%',
				innerRadius: '75%',
				dataPoints: [
					{ y: this.saveUpToPercent, color: '#FC8F3B' },
					{ y: 100 - this.saveUpToPercent, color: '#EBEBEB' }
				]
			}]
		});
		chart.render();
	}
}
